import { call, put } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import notify from 'devextreme/ui/notify';
import * as action from '../actions/zdvl';
import { post, get } from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';

export function* getZDVL({ payload }) {
  try {
    const response = yield call(post, '/grid/data/zdvl/', {
      dateFrom: payload.dateFrom,
      dateTo: payload.dateTo,
      plantId: payload.plantId,
      filter: payload.filter
    });
    yield put(action.getZDVLSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getZDVLFail());
  }
}

export function* getZDVLAccept({ payload }) {
  try {
    yield call(post, '/action/zdvl/accept', payload.list);
    yield put(action.getZDVLAcceptSuccess());
    yield put(action.getZDVL(payload.filter));
    yield call(
      notify,
      {
        message: formatMessage('dataSuccess'),
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'success',
      2000
    );
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getZDVLAcceptFail());
  }
}

export function* getZDVLDecline({ payload }) {
  try {
    yield call(post, '/action/zdvl/decline', payload.list);
    yield put(action.getZDVLDeclineSuccess());
    yield put(action.getZDVL(payload.filter));
    yield call(
      notify,
      {
        message: formatMessage('dataSuccess'),
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'success',
      2000
    );
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getZDVLDeclineFail());
  }
}

export function* getZDVLSend({ payload }) {
  try {
    yield call(post, `/action/zdvl/send/${payload.zdvlOrderNumId}`, null);
    yield put(action.getZDVLSendSuccess());
    yield put(action.getZDVL(payload.filter));
    yield call(
      notify,
      {
        message: formatMessage('dataSuccess'),
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'success',
      2000
    );
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getZDVLSendFail());
  }
}

export function* getZDVLRolls({ payload }) {
  try {
    const response = yield call(
      get,
      `/grid/zdvl/group_binding/semi_product/list?plantId=${
        payload.plantId
      }&useFifo=${payload.useFifo}&dateFrom=${payload.filter.dateFrom}&dateTo=${
        payload.filter.dateTo
      }${payload.zdvlLineNumId.map((el) => `&zdvlLineNumIds=${el}`).join('')}`
    );
    yield put(action.getZDVLRollsSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getZDVLRollsFail());
  }
}

export function* tieZDVLRolls({ payload }) {
  try {
    const response = yield call(
      post,
      `/grid/zdvl/${payload.zdvlLineNumId}/semi_product/save?plantId=${payload.plantId}&useFifo=${payload.useFifo}`,
      payload.selectedRolls
    );
    yield put(
      action.tieZDVLRollsSuccess({
        rolls: response,
        zdvlLineNumId: payload.zdvlLineNumId
      })
    );
    yield call(
      notify,
      {
        message: formatMessage('dataSuccess'),
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'success',
      2000
    );
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.tieZDVLRollsFail());
  }
}

export function* ridZDVLRolls({ payload }) {
  try {
    const response = yield call(
      post,
      `/grid/zdvl/${payload.zdvlLineNumId}/semi_product/rid`,
      payload.pieceNumIds
    );
    yield put(
      action.ridZDVLRollsSuccess({
        rolls: response,
        zdvlLineNumId: payload.zdvlLineNumId
      })
    );
    yield call(
      notify,
      {
        message: formatMessage('dataSuccess'),
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'success',
      2000
    );
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.ridZDVLRollsFail());
  }
}

export function* closeZDVL({ payload }) {
  try {
    yield call(post, '/action/zdvl/close', payload);
    yield put(action.closeZDVLSuccess());
    yield call(
      notify,
      {
        message: formatMessage('dataSuccess'),
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'success',
      2000
    );
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.closeZDVLFail());
  }
}

export function* updateZDVL({ payload }) {
  try {
    yield call(post, '/action/zdvl/decline', payload.list);
    yield put(action.getZDVL(payload.filter));
    yield put(action.updateZDVLSuccess());
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.updateZDVLFail());
  }
}

export function* getZDVLSendNotice({ payload }) {
  try {
    const emails = payload.emails ? `&emails${payload.emails}` : '';
    yield call(post, `/grid/zdvl/send/notice?plantId=${payload.plantId}${emails}`, payload.list);
    yield put(action.getZDVLSendNoticeSuccess());
    yield call(
      notify,
      {
        message: formatMessage('dataSuccess'),
        height: 64,
        width: 354,
        position: {
          at: 'top center',
          my: 'top center',
          offset: '0 48'
        }
      },
      'success',
      2000
    );
  } catch (error) {
    console.log(error);
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getZDVLSendNoticeFail());
  }
}
